import { createContext, useContext } from 'react';

/**
 * Set by the mobile card list: a column header rendered inside it is only a label (the card's field
 * name), without the sort button and filter icon, which the card list's filter dialog offers instead.
 */
export const ColumnHeaderLabelContext = createContext(false);

export const useIsColumnHeaderLabel = () => useContext(ColumnHeaderLabelContext);
